<template>
  <div id="app" class="asideCard"
       v-loading.fullscreen.lock="fullscreenLoading"
       element-loading-text="处理中…… 请耐心等待"
       element-loading-spinner="el-icon-loading"
       v-cloak>
    <!--<div id="topInst" class="topCard">
      <div class="topTitle publicTitle">
        <div class="leftTitle">实验室预约</div>
        <el-button class="rightBack" icon="el-icon-arrow-left" @click="$router.back();">返回</el-button>
      </div>
    </div>-->
    <div id="rightTable" class="searchAndTable">
      <div class="row">
        <div class="rowCenter">
          <div style="width: 210px;display: inline-block;vertical-align: top;">
            <div id="nav-body">
              <div :class="{'active':item.id==menuId,'nav-every':true}"
                   style="text-align: left"
                   v-for="(item,i) in menuList"
                   @click="toList(item.id,item.type)">
                {{item.label}}
              </div>
            </div>
          </div>

          <div style="width: 890px;display: inline-block">
            <div v-show="menuId=='1'">
              <!--实验室预约-->
              <el-row class="searForm" style="padding-left: 40px">
                <el-form :inline="true" label-width="100px" size="small">
                  <transition name="el-zoom-in-top">
                    <el-form-item label="所属中心">
                      <el-select v-model="queryLabList.orgId" @change="getLabList" filterable style="width: 220px">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in orgList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </transition>
                  <transition name="el-zoom-in-top">
                    <el-form-item label="实验室名称">
                      <el-select v-model="queryLabList.labId"  placeholder="请选择" filterable @change="changeLab" style="width: 220px">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in labList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </transition>
                  <transition name="el-zoom-in-top">
                    <el-form-item label="时段查询" v-show="show && loginStatus=='2'">
                      <el-date-picker
                        v-model="times"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间">
                      </el-date-picker>
                    </el-form-item>
                  </transition>
                  <transition name="el-zoom-in-top">
                    <el-form-item label="设备名称" v-show="show">
                      <el-input v-model="queryLabList.equName" style="width: 220px"></el-input>
                    </el-form-item>
                  </transition>
                  <transition name="el-zoom-in-top">
                    <el-form-item>
                      <el-button type="primary"  @click="queryButton">搜索</el-button>
                    </el-form-item>
                  </transition>
                  <el-form-item label="">
                    <el-button type="text"  @click="show = !show">
                      <span class="el-icon-arrow-down" v-if="!show">展开筛选</span>
                      <span class="el-icon-arrow-up" v-if="show">收起筛选</span>
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-row>
              <div class="cardList">
                <div class="card" v-for="item in mainDataList">
                  <div class="cardImg">
                    <div style="width: 50px;height: 30px;background-color: #00CC33;position: absolute;right: 0px;top: 0px;background-color: rgba(66,246,101,0.5);z-index: 100;text-align: center;line-height: 30px" v-if="item.labHoldUser != '0'">可预约</div>
                    <div style="width: 50px;height: 30px;background-color: red;position: absolute;right: 0px;top: 0px;background-color: rgba(246,77,66,0.5);z-index: 100;text-align: center;line-height: 30px" v-if="item.labHoldUser == '0'">已满</div>
                    <img :src="item.photoUrl" alt="">
                  </div>
                  <div class="cardInfo">
                    <div class="cardInfoRow">
                      <el-tooltip class="item" effect="dark" :content="item.labName" placement="top-end">
                        <span style="cursor: pointer;font-weight: 900;font-size: 12px;width: 100%">{{item.labName}}</span>
                      </el-tooltip>
                      <div style="margin-top: 5px">
                        <span v-if="item.labHoldUser == '0'">剩余容纳人数：<span style="font-size: 15px;font-weight: 900;color: red">{{item.labHoldUser}}</span>人</span>
                        <span v-if="item.labHoldUser != '0'">剩余容纳人数：<span style="font-size: 15px;font-weight: 900">{{item.labHoldUser}}</span>人</span>
                      </div>
                      <el-tooltip class="item" effect="dark" :content="'负责人：'+item.managerName" placement="top-end">
                        <span style="cursor: pointer;margin-top: 10px;width: 100%">负责人：{{item.managerName}}</span>
                      </el-tooltip>
                      <div style="margin: 25px 10px;display: flex;justify-content: flex-end">
                        <el-button type="primary" size="small" @click="toLabInfo(item)" :disabled="item.labHoldUser == '0'">预约</el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                             :current-page="queryLabList.page"
                             :page-sizes="[10, 40, 50, 60]" :page-size="queryLabList.pageSize"
                             layout="total, sizes, jumper, next, pager, prev" :total="total">
              </el-pagination>
            </div>
            <div v-if="menuId=='2' || menuId=='3' || menuId=='4' || menuId=='11'">
              <!--实验室审核-->
              <labAudit :sentType="sentType"></labAudit>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import labAudit from "@/views/insAppointmentAudit.vue";

  // 将提交数据转化为formData
  function translateForm(data) {
    var fd = new FormData();
    for (var key in data) {
      fd.append(key, data[key]);
    }
    return fd;
  }
  export default {
    name: "",
    components: { labAudit},

    data(){
      return{
        sentType:"",
        menuId:'1',
        auditList:[],//审核列表
        menuList:[
          {
            label:'实验室预约',
            id:'1',
            type:'',
          },
          /*{
            label:'设备审核（设备负责人）',
            id:'11',
            type:'audit2',
          },*/
          {
            label:'预约审核(导师)',
            id:'2',
            type:'audit4',
          },
          {
            label:'预约审核(实验中心主任)',
            id:'3',
            type:'audit3',
          },
          {
            label:'预约审核(学院管理员)',
            id:'4',
            type:'audit1',
          },
        ],
        fullscreenLoading:false,
        show:false,
        queryLabList:{
          equName:'',//设备名称
          startTime:'',//开始时间
          endTime:'',//结束时间
          orgId:'',//所属中心
          labId:'',//所属中心实验室
          labName:'',//所属中心实验室
          page: 1,
          pageSize: 10
        },
        times:[],//开始结束时间
        total:0,//总条数
        mainDataList:[],//可预约列表
        orgList:[],//实验室所属中心列表
        labList:[],//实验室列表
        loginStatus:"",//登录状态
      }
    },
    methods:{
      toList(itemId,type){
        this.menuId = itemId;
        if(itemId=='11'||itemId=='2'||itemId=='3'||itemId=='4'){
          this.sentType = type
        }
      },
      toLabInfo(item){
        var that = this;
        if(item.labHoldUser == '0'){
          that.$alert('此实验室预约已满！', '提示', {confirmButtonText: '确定'});
        }else{
          // location.href = 'http://localhost:8180/OpenLabShowInfo?resId=2009141144453585182&labId='+item.id+'&labHoldUser='+item.labHoldUser //odig-lims 配置地址 线下
          // location.href = '/OpenLabShowInfo?resId=2009141144453585182&labId='+item.id+'&labHoldUser='+item.labHoldUser //odig-lims 配置地址 线上
          that.$router.push({name:'OpenLabShowInfo' , params:{labId:item.id,labHoldUser:item.labHoldUser}});
        }
      },
      //查询
      queryButton(){
        var that=this;
        that.queryLabList.page = 1;
        that.getMainData()
      },
      // 表格中的多选框
      changeCheckFun (val) {
        var that = this;
        that.mainSelectArr = val;
      },
      // 每页条数变化
      handleSizeChange (val) {
        var that = this;
        that.queryLabList.pageSize = val;
        that.queryLabList.page = 1;
        that.getMainData()
      },
      // 页码变化
      handleCurrentChange (val) {
        var that = this;
        that.queryLabList.page = val;
        that.getMainData()
      },
      getMainData(){
        var that = this;
        if(that.times.length != 0){
          if(new Date(that.times[0]).toDateString() == new Date(that.times[1]).toDateString()){
            that.queryLabList.startTime = new Date(that.times[0]).getTime();
            that.queryLabList.endTime = new Date(that.times[1]).getTime();
          }else{
            that.$message.error('请查询同一天的时间段！');
            return;
          }
        }
        that.fullscreenLoading = true;
        var fd = translateForm(that.queryLabList);
        axios.post("/labOpen/getOpenLabList", fd, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function (response) {
          that.fullscreenLoading=false;
          that.mainDataList = response.data.data;
          that.mainDataList.forEach(function (item) {
            if(item.photo){
              item.photoUrl = "/mainsys/UserFiles/labPhoto/"+item.photo
            }else{
              item.photoUrl = require("../img/lab/labimg.png")
            }
          });
          that.total = response.data.total;
        }).catch(function(error){
          that.fullscreenLoading=false;
          that.$message.error('获取数据失败，请重试！');
        })
      },
      getOrgList(){
        var that = this;
        that.fullscreenLoading=true;
        axios.post("/baseinfo/getOrgSelectFromUser?type=3&status=2").then(function (response) {
          that.fullscreenLoading=false;
          that.orgList = response.data;
          that.queryButton();
          that.getLabList();
        }).catch(function(error){
          that.fullscreenLoading=false;
          that.$message.error('获取所属中心数据失败，请重试！');
        })
      },
      getLabList(){
        var that = this;
        that.fullscreenLoading=true;
        axios.post("/baseinfo/getLabSelectListByParentId?parentId=" + that.queryLabList.orgId).then(function (response) {
          that.fullscreenLoading=false;
          that.labList = response.data;
        }).catch(function(error){
          that.fullscreenLoading=false;
          that.$message.error('获取实验室数据失败，请重试！');
        })
      },
      changeLab(){
        var that = this;
        if(!that.queryLabList.labId){
          that.queryLabList.labName = '';
        };
        that.labList.forEach(function (item) {
          if(that.queryLabList.labId == item.id){
            that.queryLabList.labName = item.name
          }
        })
      }
    },
    created(){
      var that = this;
      that.loginStatus = sessionStorage.getItem('loginStatus') //2在登录状态下
      if(that.loginStatus!='2'){
        //没登录不可以审核
        that.menuList = [{
          label:'实验室预约',
          id:'1',
        }]
      }else{
        //

      }
      that.getMainData();
      // that.getOrgList()
    }
  }
</script>

<style scoped>
  .nav-every{
    font-size: 17px !important;
  }
  .asideCard { /*卡片的外层样式*/
    wdith: 100%;
    height: calc(100% - 30px);
    /*margin: 10px;*/
  }

  .asideCard .topCard { /*卡片的头部样式*/
    border: 1px solid #CCCDD2;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .12), 0 0 6px 0 rgba(0, 0, 0, .04);
    background: #ffffff;
  }

  .asideCard .publicTitle { /*卡片的头部标题外层样式*/
    width: 100%;
    border-bottom: 2px solid #eef0f3;
    min-height:50px;
  }

  .asideCard .leftTitle { /*卡片的头部标题样式*/
    float: left;
    color: rgb(3, 78, 161);
    font-weight: 700;
    line-height: 16px;
    padding-left: 12px;
    border-left: 3px solid rgb(3, 78, 161);
    margin-top: 16px;
    margin-left: 12px;
    font-size: 16px;
  }

  .asideCard .rightBack { /*卡片的头部返回按钮样式*/
    float: right;
    border: 0px;
    margin-right: 12px;
    margin-top: 6px
  }

  .asideCard .topDetails { /*卡片的头部内容容器样式*/
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }


  .searchAndTable { /*搜索框，操作按钮与表格外部容器的样式*/
    padding: 10px;
  }

  .searchAndTable .searForm { /*搜索框容器样式*/
    border: 0px;
    padding: 5px;
  }

  .searchAndTable .el-form-item { /*取消element表单元素底部的margin*/
    margin-bottom: 0px !important;
  }

  .searchAndTable .searchFormItem { /*搜索框内表单样式*/
    width: 280px;
    margin-bottom: 0px;
    margin-top: 10px;
  }

  .searchAndTable .searButton { /*搜索框内搜索按钮样式*/
    margin: 10px 5px 0px 5px;
  }

  .searchAndTable .operation { /*操作按钮框*/
    background-color: #ffffff;
    font-size: 0px;/*去掉按钮元素由于换行引起的空格*/
    margin-top: 10px;
    padding: 7px;
    border-top: 1px solid #CCCDD2;
    border-left: 1px solid #CCCDD2;
    border-right: 1px solid #CCCDD2;
  }

  .searchAndTable .operation .operaButton { /*操作按钮*/
    margin: 0;
    padding: 5px;
    border-right: 1px solid #979797;
    border-radius: 0px;
    font-weight: 700;
    font-size: 14px;
  }

  .searchAndTable .paginationS { /*分页组件左右边框*/
    background-color: #ffffff;
    padding: 5px;
    border-top: 1px solid #CCCDD2;
    border-left: 1px solid #CCCDD2;
    border-right: 1px solid #CCCDD2;
  }

  .searchAndTable table  a { /*表格中的a标签*/
    color: #48a6fa;
    cursor:pointer;
    margin: 0 2px;
  }

  .searchAndTable .annbtn { /*表单中注释按钮*/
    color: #777777;
    font-size: 10px;
    cursor:pointer;
  }


  .card{
    width: 350px;
    height: 170px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    margin: 15px;
    display: flex;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
  }
  .row{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .rowCenter{
    /*border: 1px solid #c3c3c3;*/
    border-radius: 5px;
    background-color: white;
    padding: 20px;
    width: 1100px;
    margin: 0 auto;
  }
  .cardList{
    margin: 20px;
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 40px;

  }
  .cardImg{
    width: 160px;
    height: 120px;
    margin: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    position: relative;
    font-size: 12px;
    color: white;
    border: 1px solid #c3c3c3;
  }
  .cardImg img{
    width: 100%;
    height: 100%;
    transition: transform 0.3s;
  }
  .cardImg img:hover{
    transform: scale(1.2)
  }
  .cardInfo{
    width: 160px;
    height: 50px;
    margin-right: 10px;
  }
  .cardInfoRow{
    width: 100%;
    margin-top: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .cardInfoRow span{
    width: 100%;
    font-size: 12px;
  }
  .el-form-item{
    margin-top: 5px;
  }
</style>
